export const SHOW_UPDATE_DIALOG = "SHOW_UPDATE_DIALOG";
export const HIDE_UPDATE_DIALOG = "HIDE_UPDATE_DIALOG";
export const FINISH_UPDATE = "FINISH_UPDATE";

export const showUpdateDialog = (registration) => ({
  type: SHOW_UPDATE_DIALOG,
  payload: { registration },
});

export const hideUpdateDialog = () => ({
  type: HIDE_UPDATE_DIALOG,
});


export const finishUpdate = () => ({
  type: FINISH_UPDATE,
});